import { Injectable } from '@angular/core';
import { DEFAULT_BRANDING_DATA } from '@app/core/constants/white-label';
import { Adapter } from '../../adapter';
import { DomainInfo } from './domain-info';

@Injectable()
export class DomainAdapter implements Adapter<DomainInfo> {
    adapt(data: any): DomainInfo {
        return {
            prefix: data.prefix || '',
            provider: data.providerName || DEFAULT_BRANDING_DATA.provider,
            name: data.solutionName || '',
            description: data.introCopy || '',
            assets: {
                favicon: data.favicon || '',
                darkLogo: data.darkLogo || '',
                lightLogo: data.lightLogo || '',
                loginProductLogo: data.loginProductLogo || '',
                providerLogo: data.providerLogo || '',
            },
            links: {
                self: data.href || '',
            },
        } as DomainInfo;
    }
}
